import React, {useContext, useState} from "react";
import logoIconWhite from "../../assets/images/icons/logo_icon_white.svg";
import {SellerContext} from "../../context/seller-context";
import {goVehisService} from "../../utils/axios";
import AppToaster from "../../components/AppToaster";
import SellerCodeReader from "../../utils/SellerCodeReader";
import Validator from "../../utils/Validator";
import analytics from "../../utils/analytics";

function ExpertHelp() {
    const seller = useContext(SellerContext);
    const phone = seller ? seller.phone : "";
    const phoneHref = "tel:" + phone.replace(/\s/g, "");
    let sellerCodeReader = new SellerCodeReader();

    const [callbackPhone, setCallbackPhone] = useState("");

    const callbackPhoneChangeHandler = (event) => {
        let value = event.target.value;
        if (Validator.nonNumbersExistsInString(value)) {
            value = value.slice(0, -1);
        }
        setCallbackPhone(value);
    };

    const callbackSubmitHandler = (event) => {
        event.preventDefault();
        goVehisService.post("/sellers/phonelead", {
                phone: callbackPhone,
                sellerEmail: seller.email,
                sellerPhone: seller.phone,
                sellerCode: sellerCodeReader.readSellerCode(),
            })
            .then(response => {
                AppToaster.show({message: response.data, intent: "primary"});
                analytics.sendEvent({
                    category: 'Bezpłatna pomoc eksperta',
                    action: 'Kliknięcie',
                    label: 'Zadzwońcie teraz',
                    value: 1
                });
                setCallbackPhone("");
            })
            .catch(() => {
                AppToaster.show({message: "Nie można zapisać leada. Spróbuj ponownie.", intent: "danger"});
            });
    };

    const [contactStatus, setContactStatus] = useState(null);

    const [contactForm, setContactForm] = useState({
        name: "",
        email: "",
        phone: "",
        message: "",
        agreement: false,
        marketingElectronic: false,
        marketingPhone: false,
    });

    const contactValueChangeHandler = (event) => {
        const {name, value} = event.target;
        setContactForm(prevState => ({...prevState, [name]: value}));
    };

    const contactPhoneChangeHandler = (event) => {
        let value = event.target.value;
        if (Validator.nonNumbersExistsInString(value)) {
            value = value.slice(0, -1);
        }
        setContactForm(prevState => ({...prevState, phone: value}));
    };

    const contactCheckboxChangeHandler = (event) => {
        const {name, checked} = event.target;
        setContactForm(prevState => ({...prevState, [name]: checked}));
    };

    const contactSubmitHandler = (event) => {
        event.preventDefault();
        const payload = {
            ...contactForm,
            sellerEmail: seller.email,
            sellerPhone: seller.phone,
            sellerCode: sellerCodeReader.readSellerCode(),
            sourceUrl: window.location.href,
        };
        goVehisService.post("/sellers/contact", payload)
            .then(response => {
                AppToaster.show({message: response.data, intent: "primary"});
                analytics.sendEvent({
                    category: 'Bezpłatna pomoc eksperta',
                    action: 'Kliknięcie',
                    label: 'Wyślij wiadomość',
                    value: 1
                });
                setContactStatus("success");
                setContactForm({
                    name: "",
                    email: "",
                    phone: "",
                    message: "",
                    agreement: false,
                    marketingElectronic: false,
                    marketingPhone: false,
                });
            })
            .catch(() => {
                AppToaster.show({message: "Ups! Wystąpił jakiś błąd. Spróbuj ponownie.", intent: "danger"});
                setContactStatus("error");
            });
    };

    return (
        <section className="expert-help-section">
            <div className="container">
                <div className="expert-help-card">
                    <div className="expert-help-top">
                        <h2 className="expert-help-heading">Bezpłatna pomoc eksperta</h2>
                        <p className="expert-help-desc">
                            Nasi eksperci są do Twojej dyspozycji. Pomożemy Ci wybrać najlepszą ofertę
                            leasingu dopasowaną do Twoich potrzeb i możliwości finansowych.
                        </p>
                    </div>
                    <div className="expert-help-cols">
                        <div className="expert-help-callback">
                            <div className="expert-help-callback__top">
                                <p className="expert-help-col-title">Nie chcesz pisać? Zadzwoń</p>
                                <a href={phoneHref} className="expert-help-phone">
                                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M18.3 13.98c-.02 0-1.97-.41-2.43-.51a1.36 1.36 0 0 0-1.32.37l-1.14 1.14a10.47 10.47 0 0 1-4.38-4.38l1.14-1.14c.36-.35.5-.85.37-1.32C10.44 7.68 10.02 5.73 10 5.7A1.37 1.37 0 0 0 8.63 4.6H5.7A1.37 1.37 0 0 0 4.33 6c.15 8.04 7.63 14.52 14 14.67A1.37 1.37 0 0 0 19.73 19.3v-2.95c0-.69-.51-1.28-1.43-1.37z" fill="#176fb7"/>
                                    </svg>
                                    {phone}
                                </a>
                            </div>
                            <form className="expert-help-callback__form" onSubmit={callbackSubmitHandler}>
                                <p className="expert-help-col-subtitle">
                                    Chcesz, żebyśmy zadzwonili do Ciebie w 120 sekund?
                                </p>
                                <div className="expert-help-field">
                                    <label className="expert-help-label">Podaj nr telefonu</label>
                                    <input
                                        type="tel"
                                        className="expert-help-input"
                                        required
                                        minLength="9"
                                        maxLength="9"
                                        pattern="[0-9]{9}"
                                        value={callbackPhone}
                                        onChange={callbackPhoneChangeHandler}
                                    />
                                </div>
                                <button type="submit" className="expert-help-btn">
                                    ZADZWOŃCIE TERAZ
                                    <img src={logoIconWhite} alt="" className="search-btn-icon"/>
                                </button>
                            </form>
                        </div>
                        <form className="expert-help-form" onSubmit={contactSubmitHandler}>
                            <div className="expert-help-field">
                                <label className="expert-help-label">Imię i nazwisko</label>
                                <input
                                    type="text"
                                    className="expert-help-input"
                                    required
                                    name="name"
                                    value={contactForm.name}
                                    onChange={contactValueChangeHandler}
                                />
                            </div>
                            <div className="expert-help-row">
                                <div className="expert-help-field">
                                    <label className="expert-help-label">Nr telefonu</label>
                                    <input
                                        type="tel"
                                        className="expert-help-input"
                                        required
                                        minLength="9"
                                        maxLength="9"
                                        pattern="[0-9]{9}"
                                        value={contactForm.phone}
                                        onChange={contactPhoneChangeHandler}
                                    />
                                </div>
                                <div className="expert-help-field">
                                    <label className="expert-help-label">Adres e-mail</label>
                                    <input
                                        type="email"
                                        className="expert-help-input"
                                        required
                                        name="email"
                                        value={contactForm.email}
                                        onChange={contactValueChangeHandler}
                                    />
                                </div>
                            </div>
                            <div className="expert-help-field">
                                <label className="expert-help-label">Wiadomość</label>
                                <textarea
                                    className="expert-help-input expert-help-textarea"
                                    rows={3}
                                    required
                                    name="message"
                                    value={contactForm.message}
                                    onChange={contactValueChangeHandler}
                                />
                            </div>
                            <div className="expert-help-checkboxes">
                                <div className="search-checkbox-row">
                                    <input
                                        type="checkbox"
                                        id="expert-consent-1"
                                        name="agreement"
                                        required
                                        checked={contactForm.agreement}
                                        onChange={contactCheckboxChangeHandler}
                                    />
                                    <label htmlFor="expert-consent-1">
                                        Wyrażam zgodę na przetwarzanie moich danych osobowych w celu kontaktu,
                                        zgodnie z polityką prywatności dostępną{" "}
                                        <a href="/rodo" className="expert-help-link">tutaj</a>.
                                    </label>
                                </div>
                                <div className="search-checkbox-row">
                                    <input
                                        type="checkbox"
                                        id="expert-consent-2"
                                        name="marketingElectronic"
                                        checked={contactForm.marketingElectronic}
                                        onChange={contactCheckboxChangeHandler}
                                    />
                                    <label htmlFor="expert-consent-2">
                                        Wyrażam zgodę na kontakt drogą elektroniczną w celach marketingowych
                                        zgodnie z{" "}
                                        <a href="/rodo" className="expert-help-link">polityką prywatności</a>.
                                    </label>
                                </div>
                                <div className="search-checkbox-row">
                                    <input
                                        type="checkbox"
                                        id="expert-consent-3"
                                        name="marketingPhone"
                                        checked={contactForm.marketingPhone}
                                        onChange={contactCheckboxChangeHandler}
                                    />
                                    <label htmlFor="expert-consent-3">
                                        Wyrażam zgodę na kontakt telefoniczny i przez systemy automatyczne
                                        zgodnie z{" "}
                                        <a href="/rodo" className="expert-help-link">polityką prywatności</a>.
                                    </label>
                                </div>
                            </div>
                            {contactStatus === "success" && (
                                <p className="home-newsletter-success">Dziękujemy! Wiadomość została wysłana.</p>
                            )}
                            {contactStatus === "error" && (
                                <p className="home-newsletter-error">Ups! Wystąpił błąd. Spróbuj ponownie.</p>
                            )}
                            <button type="submit" className="expert-help-btn">
                                WYŚLIJ
                                <img src={logoIconWhite} alt="" className="search-btn-icon"/>
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default ExpertHelp;
